import React from 'react';
import classNames from 'classnames';

import {
  DynamicMediaItem,
} from '@uncinc/react-drupal-core';
import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  ButtonWrapper,
  ParagraphsRenderer,
} from '../../../components';

import './style.scss';

const NodeLandingPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeLandingPage');
  const node = entity.toJS();
  const heroTitle = node.title[0].value;
  const heroBody = node.body[0]?.processed;
  const heroImage = node.field_media_item[0];
  const link = node.field_link[0];

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="NodeLandingPage__hero__wrapper">
              <div className="NodeLandingPage__hero__wrapper__text">
                <h1 className="NodeLandingPage__hero__wrapper__title">{heroTitle}</h1>
                {heroBody && (
                  <div className="NodeLandingPage__hero__wrapper__body">
                    <WysiwygField
                      property="schema:text"
                      className="text--large"
                      html={heroBody}
                    />
                  </div>
                )}
              </div>
              {link && (
                <div className="NodeLandingPage__hero__wrapper__button">
                  <ButtonWrapper href={link?.alias || link?.uri}>
                    {link.title}
                  </ButtonWrapper>
                </div>
              )}
            </div>
          </div>
        </div>
        {heroImage && (
          <div className="row">
            <div className="col-12">
              <div className="NodeLandingPage__hero__image">
                <DynamicMediaItem
                  media={heroImage}
                  imageAspectRatio="16_9"
                />
              </div>
            </div>
          </div>
        )}
      </Container>

      <ParagraphsRenderer paragraphs={entity.get('field_paragraphs')} isLarge />
    </article>
  );
};

export default NodeLandingPage;
